import { render } from "./ServiceDescription.vue?vue&type=template&id=041d058f"
import script from "./ServiceDescription.vue?vue&type=script&lang=js"
export * from "./ServiceDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__